import { render, staticRenderFns } from "./CloseNotificationButton.vue?vue&type=template&id=c4271f70&scoped=true"
import script from "./CloseNotificationButton.vue?vue&type=script&lang=js"
export * from "./CloseNotificationButton.vue?vue&type=script&lang=js"
import style0 from "./CloseNotificationButton.vue?vue&type=style&index=0&id=c4271f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4271f70",
  null
  
)

export default component.exports